import axios from "axios";
import { API_URL } from "./apiUrl";

// export const API_URL = 'https://montenegromice.com/mice-api';

export const fetchUnitTypes = () => {
  return axios
    .get(`${API_URL}/unit-types`)
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(error.message);
    });
};

export const deleteUnitType = (unitTypeId) => {
  return axios
    .delete(`${API_URL}/unit-types/${unitTypeId}`)
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(`Greška pri brisanju dokumenta: ${error.message}`);
    });
};

export const getUnitType = async (id) => {
  try {
    const response = await axios.get(`${API_URL}/unit-types/${id}`);
    return response.data;
  } catch (error) {
    throw new Error(`Greška pri dobavljanju dokumenta: ${error.message}`);
  }
};

export const editUnitType = async (id, unitTypeData) => {
  try {
    const response = await axios.put(
      `${API_URL}/unit-types/${id}`,
      unitTypeData
    );
    return response.data;
  } catch (error) {
    throw new Error(`Greška pri editovanju dokumenta: ${error.message}`);
  }
};

export const addUnitType = (unitTypeData) => {
  return axios
    .post(`${API_URL}/unit-types`, unitTypeData)
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(`Greška pri dodavanju dokumenta: ${error.message}`);
    });
};
